function fixMarquee(selector, speed) {
  const track = document.querySelector(selector);
  if (!track || track.children.length < 2) return;

  const items = [...track.children];
  const half = Math.floor(items.length / 2);
  if (half === 0) return;

  let totalWidth = 0;
  for (let i = 0; i < half; i++) {
    const rect = items[i].getBoundingClientRect();
    const style = getComputedStyle(track);
    const gap = parseFloat(style.columnGap) || parseFloat(style.gap) || 0;
    totalWidth += rect.width + gap;
  }

  if (totalWidth < 100) return;

  track.style.paddingLeft = '24px';

  const duration = totalWidth / speed;
  track.style.animation = 'none';
  void track.offsetHeight;

  const name = 'mq_' + Math.random().toString(36).slice(2, 8);
  const sheet = document.createElement('style');
  sheet.textContent = '@keyframes ' + name + '{0%{transform:translate3d(0,0,0)}100%{transform:translate3d(-' + totalWidth + 'px,0,0)}}';
  document.head.appendChild(sheet);
  track.style.animation = name + ' ' + duration + 's linear infinite';
}

function init() {
  fixMarquee('.reviews-carousel__track', 35);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(init, 300));
} else {
  setTimeout(init, 300);
}
